export { JobDetail } from './JobDetail';
export { ProspectsJobDetail } from './ProspectsJobDetail';
